import React, { useState, useEffect, useRef, MutableRefObject } from "react";

import useMetaSearch from "../../../shared/hooks/useMetaSearch";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./searcher-schedule.scss";

const SearcherSchedule = (props: SearcherInterface) => {
  const {
    compact,
    type,
    defaultPlaceholder,
    allSpecialist,
    setselectSpecialitsSearch,
    selectSpecialitsSearch,
    pageAtive,
    setselectSpecialist,
    setcardActvie,
  } = props;

  const node: MutableRefObject<any> = useRef();

  const [isActive, setActiveSelect] = useState(false);
  const [searchWord, setSearchWord] = useState("");

  const { doSearch } = useMetaSearch(type);
  const { document } = useBrowserMode();

  const handleClickOutside = (e: Event) => {
    if (node.current.contains(e.target)) {
      return;
    } else {
      setActiveSelect(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);

  const filterSpecialist = () => {
    let filterResult = allSpecialist.filter((specialist) =>
      specialist.name.toLowerCase().includes(searchWord.toLowerCase())
    );
    return filterResult;
  };
  return (
    <div
      className={`m-searcher-schedule-container ${
        compact ? "m-searcher-schedule-container--compact" : ""
      } ${
        type === "preguntas"
          ? "m-searcher-schedule-container--compact-extended"
          : ""
      }`}
    >
      <div
        className={`m-searcher-schedule-container m-searcher-schedule-container__content ${
          isActive || searchWord.trim().length > 0
            ? "m-searcher-schedule-container__content--active"
            : ""
        }`}
      >
        <div className="m-searcher-schedule-container__input">
          <i className="icon icon-search" />
          <input
            autoFocus
            ref={node}
            value={searchWord}
            placeholder={
              type === "preguntas"
                ? "¿Qué estás buscando?"
                : defaultPlaceholder || ""
            }
            onClickCapture={() => setActiveSelect(true)}
            onChange={(text) => {
              doSearch(text.currentTarget.value);
              setSearchWord(text.currentTarget.value);
            }}
          />
          {searchWord.trim().length > 0 && (
            <i
              className="icon icon-times-circle1"
              onClickCapture={() => {
                if (selectSpecialitsSearch !== "") {
                  setselectSpecialitsSearch("");
                }
                setSearchWord("");
                doSearch("");
              }}
            />
          )}
        </div>
        {(searchWord.trim().length > 0 || !compact) && (
          <div className="m-searcher-schedule-container__separator" />
        )}

        {searchWord.trim().length > 0 && (
          <div className="m-searcher-schedule-container__results">
            <ul>
              {filterSpecialist().map((result, index) => (
                <li
                  key={`result${index}`}
                  onClick={() => {
                    setselectSpecialitsSearch(result.id);
                    setcardActvie(result.id);
                    if (pageAtive === 3) {
                      const specialistSelect = allSpecialist.find(
                        (el) => el.id === result.id
                      );
                      setselectSpecialist(specialistSelect);
                    }
                    setSearchWord("");
                  }}
                >
                  {result.name}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

interface SearcherInterface {
  compact?: boolean;
  type?: "comfama" | "preguntas";
  onSelect?: Function;
  scrollIntoQuestion?: Function;
  defaultPlaceholder?: string;
  allSpecialist?: any;
  setselectSpecialitsSearch?: any;
  selectSpecialitsSearch?: any;
  pageAtive?: any;
  setselectSpecialist?: any;
  setcardActvie?: any;
}

export default SearcherSchedule;
